import firebase from 'firebase/app'

require('firebase/firestore')
require('firebase/auth')

const config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENTID,
}

firebase.initializeApp(config)

const db = firebase.firestore()
const auth = firebase.auth()

db.enablePersistence()
  .catch(function (err) {
    if (err.code === 'failed-precondition') {
      console.log(err.code)
    } else if (err.code === 'unimplemented') {
      console.log(err.code)

      // The current browser does not support all of the
      // features required to enable persistence
      // ...
    }
  })
// Subsequent queries will use persistence, if it was enabled successfully

export { db, auth }
